module.exports = __webpack_public_path__ + "img/sb.2763a495.svg";